export var GAME_STATUS;
(function (GAME_STATUS) {
    GAME_STATUS["AWAITING_START"] = "AWAITING_START";
    GAME_STATUS["AWAITING_FIRST_MATCH_START"] = "AWAITING_FIRST_MATCH_START";
    GAME_STATUS["RUNNING"] = "RUNNING";
    GAME_STATUS["LAST_MATCH_STARTED"] = "LAST_MATCH_STARTED";
    GAME_STATUS["EVALUATING"] = "EVALUATING";
    GAME_STATUS["EVALUATED"] = "EVALUATED";
})(GAME_STATUS || (GAME_STATUS = {}));
